import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@/assets/scsss/variables.sass'

Vue.use(Vuetify);

export default new Vuetify({
});
